<template>
  <div v-html="htmlContent" />
</template>

<script>

export default {
  data () {
    return {
      data: {}
    }
  },
  computed: {
    htmlContent () {
      const { name } = this.data
      return name + ''
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
